import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './permission'; // 权限
import i18n from './i18n';

// import 'element-ui/lib/theme-chalk/index.css';
import ElementUI from 'element-ui';
Vue.use(ElementUI, {
  size: 'mini',
  zIndex: 3000,
  i18n: (key, value) => i18n.t(key, value),
});

import API from './http/api';
import http from './http/http';
Vue.prototype.$API = API;
Vue.prototype.$http = http;

// 引入全局注册组件
import './globalComponent';

Vue.config.productionTip = false;

import '@/styles/index.scss'; // 默认皮肤样式
import '@/iconfont/default/iconfont.css'; // 引入自定义图标
import '@/iconfont/color/iconfont.css'; // 引入自定义图标

Date.prototype.Format = function (fmt) {
  const o = {
    'M+': this.getMonth() + 1, // 月份
    'd+': this.getDate(), // 日
    'h+': this.getHours(), // 小时
    'm+': this.getMinutes(), // 分
    's+': this.getSeconds(), // 秒
    'q+': Math.floor((this.getMonth() + 3) / 3), // 季度
    S: this.getMilliseconds(), // 毫秒
  };
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(
      RegExp.$1,
      (this.getFullYear() + '').substr(4 - RegExp.$1.length),
    );
  for (let k in o) {
    if (new RegExp('(' + k + ')').test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1
          ? o[k]
          : ('00' + o[k]).substr(('' + o[k]).length),
      );
  }
  return fmt;
};

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
